import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LOGO_WHITE =
  "/assets/fekkib9r_LOGO-UNIK-HOLDINGS-White-gold.png";

export default function SiteFooter() {
  const { t } = useTranslation();

  const LINKS = [
    { label: t("nav.home"), to: "/", key: "home" },
    { label: t("nav.about"), to: "/about/who-we-are", key: "about" },
    { label: t("nav.investment"), to: "/investments", key: "investment" },
    { label: t("nav.impact"), to: "/impact", key: "impact" },
    { label: t("nav.insights"), to: "/insights", key: "insights" },
    { label: t("nav.aboutMenu.careers"), to: "/about/careers", key: "careers" },
    { label: t("nav.contact"), to: "/contact", key: "contact" },
  ];

  const INVESTMENTS = [
    { label: t("footer.investmentApproach"), to: "/investments/approach", key: "approach" },
    { label: t("footer.portfolioAssets"), to: "/investments/portfolio-assets", key: "assets" },
  ];

  const PRIVACY = [
    { label: t("footer.privacyPolicy"), to: "/privacy-policy", key: "privacy" },
    { label: t("footer.terms"), to: "/terms-of-use", key: "terms" },
  ];

  return (
    <footer
      data-testid="site-footer"
      className="relative text-white overflow-hidden"
    >
      <div className="absolute inset-0 silk-bg" />
      <div className="absolute inset-0 grain pointer-events-none opacity-[0.05]" />

      <div className="relative z-10 mx-auto max-w-[1400px] px-6 lg:px-10 pt-20 pb-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 pb-16 border-b border-white/15">
          <div className="lg:col-span-5">
            <img src={LOGO_WHITE} alt="UNIK Holdings" className="h-16 w-auto" />
            <p className="mt-8 max-w-md text-white/85 text-[17px] lg:text-[18px] leading-[1.85]">
              {t("footer.tagline")}
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="eyebrow text-unik-gold" style={{ fontSize: "14px" }}>{t("footer.quickLinks")}</div>
            <ul className="mt-6 space-y-4">
              {LINKS.map((l) => (
                <li key={l.key}>
                  <Link
                    to={l.to}
                    className="text-white/85 hover:text-unik-gold text-[16px] transition-colors"
                    data-testid={`footer-link-${l.key}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="eyebrow text-unik-gold" style={{ fontSize: "14px" }}>{t("footer.investments")}</div>
            <ul className="mt-6 space-y-4">
              {INVESTMENTS.map((l) => (
                <li key={l.key}>
                  <Link
                    to={l.to}
                    className="text-white/85 hover:text-unik-gold text-[16px] transition-colors"
                    data-testid={`footer-invest-${l.key}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="eyebrow text-unik-gold mt-10" style={{ fontSize: "14px" }}>{t("footer.privacy")}</div>
            <ul className="mt-6 space-y-4">
              {PRIVACY.map((l) => (
                <li key={l.key}>
                  <Link
                    to={l.to}
                    data-testid={`footer-${l.key}-link`}
                    className="text-white/85 hover:text-unik-gold text-[16px] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-white/65 text-[13px] tracking-wider">
            {t("common.copyright")}
          </p>
          <div className="text-[13px] tracking-wider text-white/65">
            {t("common.vietnam")}
          </div>
        </div>
      </div>
    </footer>
  );
}
